// The product tour runs for new free-plan INT users and every UAE programme agent (any access level).
export const canRunProductTour = (viewer: { isFreePlanUser: boolean; isUae: boolean }): boolean =>
  viewer.isFreePlanUser || viewer.isUae;

// Auto-start on the first /dashboard visit; start() re-checks seen/active.
export const shouldAutoStartTour = (input: {
  isFreePlanUser: boolean;
  isUae: boolean;
  path: string;
  seen: boolean;
  active: boolean;
}): boolean => canRunProductTour(input) && input.path === '/dashboard' && !input.seen && !input.active;

export const PRODUCT_TOUR_ACTIVE_KEY = 'freeTierTour:active';

// After the first finished or skipped run, INT free-plan users get the pricing popup once; UAE agents get nothing.
export const shouldOpenPlansAfterTour = (input: { firstRun: boolean; isUae: boolean }): boolean =>
  input.firstRun && !input.isUae;

// First matching element that is actually rendered (display:none / detached nodes have no client rects).
export const findVisibleTarget = (candidates: Iterable<Element>): Element | null => {
  for (const el of candidates) if (el.getClientRects().length > 0) return el;
  return null;
};
